import { render, staticRenderFns } from "./CRMFailRuleDataModal.vue?vue&type=template&id=4c815166&scoped=true"
import script from "./CRMFailRuleDataModal.vue?vue&type=script&lang=js"
export * from "./CRMFailRuleDataModal.vue?vue&type=script&lang=js"
import style0 from "./CRMFailRuleDataModal.vue?vue&type=style&index=0&id=4c815166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c815166",
  null
  
)

export default component.exports